import { render, staticRenderFns } from "./AnyDocumentUploadBox.vue?vue&type=template&id=011221dc&scoped=true&"
import script from "./AnyDocumentUploadBox.vue?vue&type=script&lang=js&"
export * from "./AnyDocumentUploadBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011221dc",
  null
  
)

export default component.exports